import { Box } from '@mui/material'
import {
  DASHBOARD_CANDIDATE_STATUS_COLOR,
  DASHBOARD_CANDIDATE_STATUS_LABEL,
  DISPLAY_STATUS_MESSAGES
} from '../../utils/constant'
import { TOOLTIPS } from '../../utils/tooltips'
import CustomChip from '../chip'
import CustomTooltip from '../custom-tooltip'
import Icon from '../icon'
import { memo, useMemo } from 'react'

const CandidateStatusChip = ({
  displayStatus,
  status,
  data,
  disableTooltip = false
}) => {
  const displayLabel = useMemo(() => {
    return (
      DASHBOARD_CANDIDATE_STATUS_LABEL[displayStatus] || displayStatus || status
    )
  }, [displayStatus, status])

  const statusMsg = useMemo(() => {
    return DISPLAY_STATUS_MESSAGES?.[displayStatus]
  }, [displayStatus])

  const rawMessage = useMemo(() => {
    return statusMsg?.message || TOOLTIPS?.[status]
  }, [statusMsg, status])

  const tooltipMessage = useMemo(() => {
    return typeof rawMessage === 'function'
      ? rawMessage(status, data)
      : rawMessage
  }, [rawMessage, status, data])

  return (
    <Box sx={{ display: 'inline-flex' }}>
      <CustomChip
        rounded
        size="small"
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box component="span">{displayLabel}</Box>
            {!disableTooltip && tooltipMessage && (
              <CustomTooltip message={tooltipMessage}>
                <Box
                  component="span"
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Icon
                    icon="material-symbols:info-outline"
                    style={{ fontSize: 15, color: 'inherit', opacity: 0.9 }}
                  />
                </Box>
              </CustomTooltip>
            )}
          </Box>
        }
        {...(DASHBOARD_CANDIDATE_STATUS_COLOR?.[displayStatus]
          ? { color: DASHBOARD_CANDIDATE_STATUS_COLOR[displayStatus] }
          : {})}
      />
    </Box>
  )
}

export default memo(CandidateStatusChip)
